import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';

@inject('transferStore', 'parameterStore', 'stationStore')
@observer
class TableDetail extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    transferStore: PropTypes.object.isRequired,
    parameterStore: PropTypes.object.isRequired,
  }

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }


  slug = '/tools/data_movement';
  title = 'Movement Details';

  @observable stations = []
  @observable parameters = []
  @observable selectedTab = 'stations'

  componentWillMount() {
    const { params: { id }, transferStore } = this.props;
    transferStore.fetchItem(+id);
    this.reset();
  }

  @action reset() {
    const { params: { id }, transferStore } = this.props;
    const foundUnit = transferStore.findById(id);
    if (foundUnit) {
      const item = foundUnit.asJson || foundUnit;
      console.log(item)
      this.stations = item.stations;
      this.parameters = item.parameters;
    }
  }
  render() {
    const { parameterStore, transferStore, stationStore, params: { id } } = this.props;

    if (transferStore.isLoading || stationStore.isLoading || parameterStore.isLoading) return <Spinner />;
    return (
      <Modal title={this.title} slug={this.slug} >
        <div className="TabBar TabBarRounded">
          <ul>
            <li className={this.selectedTab === "stations" ? "active" : ""} onClick={() => this.selectedTab = "stations"}>
              <a>Stations</a>
            </li>
            <li className={this.selectedTab === "parameters" ? "active" : ""} onClick={() => this.selectedTab = "parameters"}>
              <a>Parameters</a>
            </li>
          </ul>
        </div>
        {this.selectedTab === "stations" &&
          <div className='bordered'>
            <div className='DataTable'>
              <table>
                <tbody>
                  {this.stations.map((item, index) => {
                    return (<tr>
                      <th>{item.station_id}</th>
                      <td>{stationStore.findById(+item.station_id).name}</td>
                    </tr>
                    )
                  })
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        {this.selectedTab === "parameters" &&
          <div className='bordered'>
            <div className='DataTable'>
              <table>
                <tbody>
                  {this.parameters.map((item, index) => {
                    return (<tr>
                      <th>{item.parameter_id}</th>
                      <td>{parameterStore.findById(+item.parameter_id).name}</td>
                    </tr>
                    )
                  })
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </Modal>
    );
  }
}

export default TableDetail;



// WEBPACK FOOTER //
// ./src/components/Tools/DataMovement/BetweenTables/TableDetail.js